module.exports = __webpack_public_path__ + "static/media/Teil_1.4b55891e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_1.mp4
// module id = 111
// module chunks = 0